var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Overlay',[_c('NewcrossLoader',{staticClass:"inverted"}),(typeof _vm.text !== 'boolean')?_c('h1',{staticClass:"loading-text",domProps:{"textContent":_vm._s(_vm.text)}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }